<template>
  <div class="animated fadeIn">
    <loader :show="enviando"/>
    <b-card>
    <b-button variant="secondary" @click="regresar()"> Regresar </b-button>  
      <b-card-title style="text-align: center">Listado de preguntas
      </b-card-title>
      <b-col md="12" style="text-align: end">
        <b-button  v-if="puedeAdministrar" size="sm" variant="primary" @click="abrirForm=true, nuevo=true">  Nueva pregunta  </b-button>
      </b-col>
      <br>
      <b-list-group>
        <b-list-group-item  v-for="(element, index) in arregloSevac" :key="index">    
          <b-link  @click="descargar(element)">{{element.titulo}}</b-link >
          <b-button-group v-if="puedeAdministrar" size="sm" class="pull-right">
            <b-button size="sm" :variant="element.visible ? 'outline-success' : 'outline-secondary'" @click="visible(element._id)">
              <i :class="element.visible ? 'fa fa-lg fa-globe': 'fa fa-lg fa-globe'"></i>
            </b-button>
            <b-button variant="outline-secondary" v-b-tooltip.hover title="Modificar" @click="editar(element)">
              <i class="fa fa-pencil fa-lg"></i>
            </b-button>
            <b-button variant="outline-secondary" v-b-tooltip.hover title="Modificar Archivo" @click="modificarArchivo(element._id)">
              <i class="fa fa-file fa-lg"></i>
            </b-button>
            <b-button variant="outline-secondary" @click="eliminar(element._id)"  v-b-tooltip.hover title="Eliminar">
              <i class="fa fa-trash fa-lg"></i>
            </b-button>
          </b-button-group>
        </b-list-group-item>  
      </b-list-group>
    </b-card>
    <formArchivo
      v-if="abrirForm"
      :mostrar="abrirForm"
      :trimestre="$route.params.id"
      :editarSevac="editarSevac"
      :editarArchivo="editarArchivo"
      :nuevo="nuevo"
      @cancelar="abrirForm=false, nuevo=false, editarArchivo=null, editarSevac=null"
      @documentoCargado="documentoCargado"
      @editado="sevacEditado"
    />
  </div>
</template>

<script>

import swal from 'sweetalert'
import axios from 'axios'
import Loader from '../Loader'
import { mapGetters } from "vuex";
import formArchivo from './agregarArchivo.vue'
export default {
  name: 'sevac',
  components: { Loader, formArchivo },
  computed: {
    ...mapGetters(["httpURL","sessionToken","permisos","role" ]),
    puedeAdministrar(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 228) >= 0 ) return true;
      else return false;
    },
     puedeDescargar(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 227) >= 0 ) return true;
      else return false;
    },
  },
  data: function () {
    return {
      titulo: this.$route.name,
      enviando: false,
      arregloSevac: [],
      abrirForm:false,
      nuevo:null,
      editarSevac:null,
      editarArchivo:null
    }
  },
  created(){

      // if( this.role != 'administrador' && this.permisos.findIndex(x => x.numero == 227) == -1 ) {

      //  this.$router.go(-1);
      // }
      this.enviando = true;
      
      
      axios.get(this.httpURL+'/tesoreria/trimestre/'+this.$route.params.id+'/sevac',
        {headers:{token:this.sessionToken}})
        .then(res => {
            this.enviando = false;
            this.arregloSevac = res.data.sevac;
            this.enviando = false;
        })
        .catch(error => {
            if(error){
                swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
            }
            this.enviando = false;
        });
  },
  methods: {
       regresar(){
        this.$router.go(-1);
    },
    documentoCargado(data){
      this.nuevo=null
      this.arregloSevac.push(data)
    },
    editar(elemento){
     this.editarSevac=elemento
     this.abrirForm=true;
    },
    modificarArchivo(id){
      this.editarArchivo = id,
      this.abrirForm = true
    },
    sevacEditado(data){
      let index = this.arregloSevac.findIndex(x=>x._id==data._id)
      if(index!=-1) this.arregloSevac.splice(index,1,data)
    },
    eliminar(id){
        //axios de eliminar
        this.enviando=true;
         axios.delete(this.httpURL +"/tesoreria/trimestre/"+this.idTrimestre+"/sevac/"+id,
                { headers: { token: this.sessionToken } })
              .then(res => {
                if (res.data.ok) {
                  this.$notify({
                    group: "foo",
                    type: "success",
                    duration: 2500,
                    speed: 1000,
                    text: res.data.mensaje
                  });
                 
                  let index = this.arregloSevac.findIndex(x=>x._id==id)
                  if(index!=-1)this.arregloSevac.splice(index,1)
                }

                this.enviando = false;
              })
              .catch(error => {
                this.$notify({
                  group: "foo",
                  type: "error",
                  duration: 2500,
                  speed: 1000,
                  text: "No se pudo eliminar la sección."
                });
                this.enviando = false;
               
              });
       
    },
    visible(id){
      this.enviando=true;
       axios.put(this.httpURL +"/tesoreria/sevac/visible/"+id,
        {},
        { headers: { token: this.sessionToken } })
        .then(res => {
          if (res.data.ok) {
            this.$notify({ group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
            let index = this.arregloSevac.findIndex(x=>x._id==id)
            if(index!=-1)this.arregloSevac[index].visible = res.data.visible
          }

          this.enviando = false;
        })
              .catch(error => {
                this.$notify({
                  group: "foo",
                  type: "error",
                  duration: 2500,
                  speed: 1000,
                  text: "No se pudo eliminar la sección."
                });
                this.enviando = false;
               
              });
       
    },
    descargar(e){
      this.enviando = true;
      axios({
        method: "get",
        url: this.httpURL + "/tesoreria/sevac/descargar/" + e._id,
        responseType: "arraybuffer",
        headers: { token: this.sessionToken }
        })
        .then(res => {
         let blob = new Blob([res.data], { type: 'application/pdf' }),
          url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = url;
          a.download = `${e.titulo}.pdf`;
          a.click();
          window.URL.revokeObjectURL(url);
          this.enviando = false;
        })
        .catch(err => {
          this.enviando = false;
          this.$notify({group: "gral_notif", type: "error",  duration: 1500, speed: 500,text: "No se pudo establecer una conexión al servidor."});
        });

    }
  }
}
</script>
